// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8223c713","455":"33fbb8d0","977":"b1a93d31"}[chunkId] + ".chunk.js";
};